export default __webpack_public_path__ + "static/media/What we do-eachpage-MobileApp.541e8e51.png";